<template>
  <nav
    role="navigation"
    aria-label="dropdown navigation"
  >
    <RouterLink
      v-if="isSuperAdmin"
      class="navbar-item is-flex"
      :to="{ name: 'SuperAdmin' }"
    >
      <BIcon icon="account-supervisor" />
      <span>Admin</span>
    </RouterLink>

    <RouterLink
      class="navbar-item is-flex link-sidebar-dashboard"
      :to="{ name: 'Dashboard' }"
    >
      <BIcon icon="view-dashboard" />
      <span>Dashboard</span>
    </RouterLink>

    <RouterLink
      class="navbar-item is-flex link-sidebar-calendar"
      :to="{ name: 'DebtsCalendar' }"
    >
      <BIcon icon="calendar" />
      <span>Calendario</span>
    </RouterLink>

    <RouterLink
      class="navbar-item is-flex link-sidebar-history"
      :to="{ name: 'StampedList', query: { size: 20, page: 1 } }"
    >
      <BIcon icon="format-list-bulleted" />
      <span>Historial</span>
    </RouterLink>

    <div
      class="navbar-item has-dropdown"
      :class="{ 'is-active': activeMenus.includes('invoices') }"
    >
      <a
        class="navbar-link is-flex link-sidebar-cfdis"
        @click="activeMenu('invoices')"
      >
        <BIcon icon="bank" />
        <span class="">
          CFDIS
        </span>
      </a>

      <div class="navbar-dropdown">
        <RouterLink
          class="navbar-item is-flex link-sidebar-new-invoice"
          :to="{ name: 'NewInvoice' }"
        >
          <BIcon icon="plus" />
          <span>Factura</span>
        </RouterLink>

        <RouterLink
          class="navbar-item is-flex link-sidebar-auto-invoice"
          :to="{ name: 'NewAutoInvoice' }"
        >
          <BIcon icon="auto-fix" />
          <span>Autofactura</span>
        </RouterLink>

        <RouterLink
          class="navbar-item is-flex link-sidebar-new-credit-note"
          :to="{ name: 'NewCreditNote' }"
        >
          <BIcon icon="credit-card-plus" />
          <span>Nota de Crédito</span>
        </RouterLink>

        <RouterLink
          class="navbar-item is-flex link-sidebar-new-rep"
          :to="{ name: 'NewRep' }"
        >
          <BIcon icon="file-document-box-outline" />
          <span>Complemento de Pago</span>
        </RouterLink>

        <RouterLink
          class="navbar-item is-flex link-sidebar-new-transfer"
          :to="{ name: 'TradeTransfer' }"
        >
          <BIcon icon="truck-delivery" />
          <span>Traslado</span>
        </RouterLink>

        <RouterLink
          class="navbar-item is-flex link-sidebar-new-payroll"
          :to="{ name: 'NewPayroll' }"
        >
          <BIcon icon="cash-multiple" />
          <span>Nómina</span>
        </RouterLink>
      </div>
    </div>

    <div
      class="navbar-item has-dropdown"
      :class="{ 'is-active': activeMenus.includes('receipts') }"
    >
      <a
        class="navbar-link is-flex link-sidebar-receipts"
        @click="activeMenu('receipts')"
      >
        <BIcon icon="receipt" />
        <span class="">
          Notas
        </span>
      </a>

      <div class="navbar-dropdown">
        <RouterLink
          class="navbar-item is-flex link-sidebar-new-sale-note"
          :to="{ name: 'NewSaleNote' }"
        >
          <BIcon icon="file-document-box-outline" />
          <span>Nota de Remisión</span>
        </RouterLink>
        <RouterLink
          class="navbar-item is-flex link-sidebar-new-salary-receipt"
          :to="{ name: 'NewSalaryReceipt' }"
        >
          <BIcon icon="ballot-outline" />
          <span>Recibo de salario</span>
        </RouterLink>
      </div>
    </div>

    <RouterLink
      class="navbar-item is-flex link-sidebar-products"
      :to="{ name: 'SkuCatalog' }"
    >
      <BIcon icon="barcode" />
      <span>Productos</span>
    </RouterLink>

    <RouterLink
      class="navbar-item is-flex link-sidebar-customers"
      :to="{ name: 'Customers' }"
    >
      <BIcon icon="account-group" />
      <span>Clientes</span>
    </RouterLink>

    <RouterLink
      class="navbar-item is-flex link-sidebar-employees"
      :to="{ name: 'Employees' }"
    >
      <BIcon icon="briefcase-outline" />
      <span>Empleados</span>
    </RouterLink>

    <RouterLink
      v-if="haveMultiUser"
      class="navbar-item is-flex link-sidebar-secondary-users"
      :to="{ name: 'SecondaryUsers' }"
    >
      <BIcon icon="account-supervisor" />
      <span>Usuarios</span>
    </RouterLink>
  </nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

const VALID_ROLES = ['admin', 'totalplay'];

export default {
  name: 'AppMenu',
  computed: {
    ...mapState({
      activeMenus: state => state.ui.activeMenus,
      role: state => state.auth.role,
      packages: state => state.auth.packages,
    }),
    isSuperAdmin() {
      return VALID_ROLES.includes(this.role);
    },
    haveMultiUser() {
      if (!this.packages) return false;
      return (this.role === 'main' && this.packages.includes('UsuAdicionalInc'));
    },
  },
  methods: {
    ...mapMutations({
      addActiveMenu: 'ui/addActiveMenu',
    }),
    ...mapMutations({
      deleteActiveMenu: 'ui/deleteActiveMenu',
    }),
    activeMenu(menu) {
      if (this.activeMenus.includes(menu)) this.deleteActiveMenu(menu);
      else this.addActiveMenu(menu);
    },
  },
};
</script>

<style scoped>
.navbar-item,
.navbar-item.has-dropdown .navbar-link {
  padding: 0.75rem 1.75rem;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
}

.navbar-item.has-dropdown .navbar-link {
  width: 100%;
}

.navbar-item.has-dropdown {
  padding: 0;
}

.navbar-item .icon {
  padding-right: .5rem;
}

.navbar-item:hover span,
.navbar-item:hover .icon i {
  color: #39455B;
}

.navbar-item.router-link-exact-active {
  background: rgba(255, 255, 255, .1);
}

.navbar.is-primary .navbar-item.has-dropdown .navbar-link:hover {
  color: white;
}

.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,
.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link {
  background: none;
}

.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link {
  background-color: #e8e8e8;
}

.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link .icon i,
.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link span {
  color: #39455B!important;
}

.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link:not(.is-arrowless)::after {
  transform: rotate(135deg);
  top: 59%;
}

.navbar-dropdown a.navbar-item {
  padding-right: 2rem;
  padding-left: 2.5rem;
}

.navbar-item.has-dropdown .navbar-item:hover span,
.navbar-item.has-dropdown .navbar-item:hover .icon i {
  color: #39455B;
}

@media screen and (min-width: 1088px){
  .navbar {
    flex-direction: column;
  }

  .navbar .navbar-dropdown {
    box-shadow: none;
    border-top: 0px;
    border-bottom: 0px;
  }

  .navbar-item.has-dropdown {
    flex-direction: column;
  }

  .navbar-dropdown {
    background: none;
    position: relative;

    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    border-left: 1px solid #dbdbdb;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
